module.exports = __webpack_public_path__ + "img/match-report_new.51533dc1.svg";